import { AppContextInitialState } from "../Helpers/Enums";
import { AppReducerActions } from "../ReducerActions/AppReducerActions";

const InitialState = {
  ...AppContextInitialState,
};

export const AppReducer = (state = InitialState, action) => {
  switch (action.type) {
    case AppReducerActions.PAGE_DATA_CHANGED: {
      const { pageDataChanged } = action;
      return { ...state, pageDataChanged };
    }

    case AppReducerActions.TOGGLE_LOADER: {
      const { value } = action;
      return { ...state, isLoading: value };
    }

    case AppReducerActions.SHOW_TOAST: {
      const { message, toastType } = action;
      return {
        ...state,
        showToast: !state.showToast,
        toastMessage: message,
        toastType,
      };
    }

    case AppReducerActions.SHOW_ACTIONPOPUP: {
      const {
        title,
        description,
        confirmButtonLabel,
        disableCancelBtn,
        cancelButtonLabel,
      } = action;
      return {
        ...state,
        actionPopUp: {
          isOpen: true,
          title,
          description,
          confirmButtonLabel,
          disableCancelBtn,
          cancelButtonLabel,
        },
      };
    }
    case AppReducerActions.CLOSE_ACTIONPOPUP: {
      return {
        ...state,
        actionPopUp: {
          isOpen: false,
          ...AppContextInitialState.actionPopUp,
        },
      };
    }
    case AppReducerActions.SHOW_TOPMENU: {
      const { value } = action;
      return {
        ...state,
        showTopMenu: value,
      };
    }
    case AppReducerActions.SET_ACTIVETAB: {
      const { value } = action;
      return {
        ...state,
        activeTab: value,
      };
    }

    case AppReducerActions.SET_PATIENT_CONFIG_DATA: {
      const { data } = action;
      return { ...state, patientConfigData: data };
    }

    case AppReducerActions.SET_ISACTIVE_SIDEMENU: {
      const { value } = action;

      return { ...state, isSideMenuActive: value };
    }
    case AppReducerActions.SET_PAGE_CONFIG: {
      const newConfig = action.value;

      if (
        state.pageConfig &&
        state.pageConfig.activePageId === newConfig.activePageId &&
        JSON.stringify(state.pageConfig.navigatePaths) ===
          JSON.stringify(newConfig.navigatePaths) &&
        state.pageConfig.customCssClass === newConfig.customCssClass
      ) {
        return state;
      }

      return {
        ...state,
        pageConfig: newConfig,
      };
    }

    // case AppReducerActions.SHOW_ABSTRACTOR_POPUP: {
    //   const {value} = action
    //   return{
    //     ...state,
    //     abstractorPopUp: {
    //       ...state.abstractorPopUp,
    //       isOpen: value
    //     }
    //   }
    // }
    // case AppReducerActions.CLOSE_ABSTRACTOR_POPUP: {
    //   return{
    //     ...state,
    //     isAbstractorPopupOpen: false
    //   }
    // }

    default:
      return { ...state };
  }
};
